import "./Assets/styles/index.css";
import "./Assets/styles/boilers.css";
import "./Assets/styles/questions.css";
import "./Assets/styles/postcode.css";
import "./Assets/styles/prices.css";
import "./Assets/styles/quoteModa.css";
import "./Assets/styles/global.css";
import "./Assets/styles/mobileNav.css";
import "./Assets/styles/popups.css";
import "./Assets/styles/conditions.css";
import "./Assets/styles/faqtwo.css";
import "./Assets/styles/contact.css";
import "./Assets/styles/video.css";
import "./Assets/styles/blogpost.css";
import "./Assets/styles/callus.css";
import "./Assets/styles/comingsoon.css";
import "./Assets/styles/loading.css";
import "./Assets/styles/snags.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import Commercial from "./pages/Commercial";
import Boilers from "./pages/Boilers";
import Navbar from "./components/navbar-footer-components/Navbar";
import MobileNav from "./components/navbar-footer-components/MobileNav";
import NavbarMenu from "./components/navbar-footer-components/NavbarMenu";
import MessageBar from "./components/navbar-footer-components/MessageBar";
import Footer from "./components/navbar-footer-components/Footer";
import QuestionOne from "./pages/boiler-quote-pages/QuestionOne";
import QuestionTwo from "./pages/boiler-quote-pages/QuestionTwo";
import QuestionThree from "./pages/boiler-quote-pages/QuestionThree";
import QuestionFour from "./pages/boiler-quote-pages/QuestionFour";
import QuestionFive from "./pages/boiler-quote-pages/QuestionFive";
import QuestionSix from "./pages/boiler-quote-pages/QuestionSix";
import QuestionSeven from "./pages/boiler-quote-pages/QuestionSeven";
import QuestionEight from "./pages/boiler-quote-pages/QuestionEight";
import Postcode from "./pages/boiler-quote-pages/Postcode";
import Prices from "./pages/boiler-quote-pages/Prices";
import BoilerService from "./pages/BoilerService";
import BoilerRepairs from "./pages/BoilerRepairs";
import Bathrooms from "./pages/Bathrooms";
import Plumbing from "./pages/Plumbing";
import UnderfloorHeating from "./pages/UnderfloorHeating";
import PrivateRental from "./pages/commercial-pages/PrivateRental";
import BlockManagement from "./pages/commercial-pages/BlockManagement";
import HousingAssociation from "./pages/commercial-pages/HousingAssociation";
import SupportContracts from "./pages/commercial-pages/SupportContracts";
import InsuranceContracts from "./pages/commercial-pages/InsuranceContracts";
import CareHomes from "./pages/commercial-pages/CareHomes";
import FaqPage from "./pages/company-pages/FaqPage";
import Partners from "./pages/company-pages/Partners";
import Conditions from "./pages/company-pages/Conditions";
import Contact from "./pages/company-pages/Contact";
import BoilerGuide from "./pages/blog-posts/BoilerGuide";
import SmartThermo from "./pages/blog-posts/SmartThermo";
import BathroomCheck from "./pages/blog-posts/BathroomCheck";
import ComingSoon from "./components/ComingSoon";
import Careers from "./pages/company-pages/Careers";
import Cancel from "./pages/Cancel";
import Success from "./pages/Success";
import "@stripe/stripe-js";

function App() {
  return (
    <div className="App">
      <Router>
        <MessageBar />
        <Navbar />
        <NavbarMenu />
        <MobileNav />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route exact path="/boilers">
            <Boilers />
          </Route>
          <Route exact path="/boiler-service">
            <BoilerService />
          </Route>
          <Route exact path="/boiler-repair">
            <BoilerRepairs />
          </Route>
          <Route exact path="/boiler-repair">
            <BoilerRepairs />
          </Route>
          <Route exact path="/bathrooms">
            <Bathrooms />
          </Route>
          <Route exact path="/plumbing">
            <Plumbing />
          </Route>
          <Route exact path="/underfloor-heating">
            <UnderfloorHeating />
          </Route>
          <Route exact path="/private-rental-sector">
            <PrivateRental />
          </Route>
          <Route exact path="/block-management-services">
            <BlockManagement />
          </Route>
          <Route exact path="/housing-assocation-services">
            <HousingAssociation />
          </Route>
          <Route exact path="/support-contracts">
            <SupportContracts />
          </Route>
          <Route exact path="/insurance-contracts">
            <InsuranceContracts />
          </Route>
          <Route exact path="/care-homes">
            <CareHomes />
          </Route>

          <Route exact path="/faq">
            <FaqPage />
          </Route>
          <Route exact path="/partners">
            <Partners />
          </Route>
          <Route exact path="/terms-and-conditions">
            <Conditions />
          </Route>
          <Route exact path="/contact-us">
            <Contact />
          </Route>

          <Route exact path="/careers">
            <Careers />
          </Route>

          <Route exact path="/commercial">
            <Commercial />
          </Route>
          <Route exact path="/contact">
            <Contact />
          </Route>

          <Route exact path="/boiler-buying-guide">
            <BoilerGuide />
          </Route>
          <Route exact path="/do-smart-thermostats-save-money">
            <SmartThermo />
          </Route>
          <Route exact path="/checklist-for-planning-a-new-bathroom">
            <BathroomCheck />
          </Route>

          <Route exact path="/coming-soon">
            <ComingSoon />
          </Route>

          <Route exact path="/success">
            <Success />
          </Route>
          <Route exact path="/cancel">
            <Cancel />
          </Route>

          <Route exact path="/question-one">
            <QuestionOne />
          </Route>
          <Route exact path="/question-two">
            <QuestionTwo />
          </Route>
          <Route exact path="/question-three">
            <QuestionThree />
          </Route>
          <Route exact path="/question-four">
            <QuestionFour />
          </Route>
          <Route exact path="/question-five">
            <QuestionFive />
          </Route>
          <Route exact path="/question-six">
            <QuestionSix />
          </Route>
          <Route exact path="/question-seven">
            <QuestionSeven />
          </Route>
          <Route exact path="/question-eight">
            <QuestionEight />
          </Route>
          <Route exact path="/postcode">
            <Postcode />
          </Route>
          <Route exact path="/prices">
            <Prices />
          </Route>
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
